import { Component, OnInit, ViewChild, ElementRef, Renderer2, Input } from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { FormControl, Validators } from '@angular/forms';
import { Parametric } from '../../cliente/parametric.model';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { MatChipInputEvent, MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material';

@Component({
  selector: 'app-chip-list-autocomplete',
  templateUrl: './chip-list-autocomplete.component.html',
  styleUrls: ['./chip-list-autocomplete.component.scss']
})

export class ChipListAutocompleteComponent implements OnInit {
  @Input() modelo: Parametric;
  @Input() label: string;
  @Input() selectedOptions: any[];
  @Input() options: any;
  @Input() maxSelection = 0;

  @Input() errorState = false;
  @Input() errorHint: string;

  filteredOptions: Observable<any[]>;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  separatorKeysCodes: number[] = [ENTER];

  myControl: FormControl = new FormControl();
  @ViewChild('clienteInput') clienteInput: ElementRef;

  private paisCtrl: FormControl;
  public focused = false;
  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    private renderer: Renderer2) {
  }

  ngOnInit() {
    if (!(this.options instanceof Observable)) {
      this.options = Observable.of(this.options);
    }
    this.options.toPromise().then(opts => {
      this.filteredOptions = this.toppings.valueChanges.pipe(
                                                          startWith(null),
                                                          map((opt: string | null) => opt ? this._filter(opt, opts) : opts));

    });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  remove(option: any): void {
    const index = this.selectedOptions.indexOf(option);
    if (index >= 0) {
      this.selectedOptions.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedOptions.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.toppings.setValue(null);
  }

  inputClicked() {
    this.fruitInput.nativeElement.blur();
    this.fruitInput.nativeElement.focus();
  }

  public isSelected(opt: any): boolean {
    for (const optSelected of this.selectedOptions) {
      if (opt.id === optSelected.id) {
        return true;
      }
    }
    return false;
  }

  public disable(opt: any): boolean {
    if (this.maxSelection > 0 && this.selectedOptions && this.selectedOptions.length >= this.maxSelection) {
      return true;
    }

    for (const optSelected of this.selectedOptions) {
      if (opt.id === optSelected.id) {
        return true;
      }
    }
    return false;
  }

  private _filter(value: any, options: any[]): any[] {
    const filterValue = value.description ? value.description.toLowerCase() : value.toLowerCase();
    return options.filter(opt => opt.description.toLowerCase().indexOf(filterValue) === 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/chip-list-autocomplete/chip-list-autocomplete.component.ts